import { getUTMName } from './util'

export default {
  methods: {
    // Parameters of resource & type
    getUTMLink: function (url, resource = 'resource', utmType = 'web') {
      // Set up UTM source as variable
      let utmSource = '?utm_source='

      if (url.includes('?')) {
        utmSource = utmSource.replace('?', '&')
      }

      // Check app variable
      switch (process.env.APP_NAME.toLowerCase()) {
        case 'neweng':
          // Update from neweng to engcom
          return url + utmSource + 'engcom_' + resource +
              '&utm_medium=' + utmType
        case 'ajas':
          // Check for legal
          if (window.location.pathname.includes('legal')) {
            return url + utmSource + 'pb' + process.env.APP_NAME.toLowerCase()
          }
          // Update to follow Ajas
          return url + utmSource + 'pb' + resource + '&utm_medium=' + utmType
        default:
          // Check for legal
          if (window.location.pathname.includes('legal')) {
            return url + utmSource + process.env.APP_NAME.toLowerCase()
          }
          // Default for other apps
          return url + utmSource + 'pb' + getUTMName().toLowerCase() +
                  '_' + resource + '&utm_medium=' + utmType
      }
    }
  }
}
